interface SelfDirectedSectionProps {
  /** Title line 1 (primary blue) — split A/B for mobile linebreak; desktop joins with space */
  titlePrimaryA: string
  titlePrimaryB: string
  /** Title line 2 (high black) — split similarly */
  titleHighA: string
  titleHighB: string
  /** Body text with explicit \n hard breaks */
  body: string
  emphasis: string
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function SelfDirectedSection({
  titlePrimaryA,
  titlePrimaryB,
  titleHighA,
  titleHighB,
  body,
  emphasis,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: SelfDirectedSectionProps) {
  return (
    <section id="self-directed" data-marketing-section="" className="w-full bg-qb-bg py-14 lg:py-[104px] tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0">
        <div data-testid="text-image-split" className="flex flex-col lg:flex-row items-center gap-14 lg:gap-0">
          {/* Text block */}
          <div className="w-full lg:w-[437px] lg:shrink-0 flex flex-col gap-10 text-center lg:text-left">
            <h2 className="font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
              <span className="block text-qb-primary whitespace-nowrap">
                {titlePrimaryA}
                <br className="lg:hidden" aria-hidden />{' '}
                {titlePrimaryB}
              </span>
              <span className="block mt-1 text-qb-text-high whitespace-nowrap">
                {titleHighA}
                <br className="lg:hidden" aria-hidden />{' '}
                {titleHighB}
              </span>
            </h2>
            <div className="flex flex-col gap-6">
              <p className="font-normal text-qb-text-mid text-[18px] lg:text-[20px] leading-[1.5] whitespace-pre-line">
                {body}
              </p>
              <p className="font-bold text-qb-text-high text-[20px] lg:text-[24px] leading-[1.5] lg:leading-[1.4]">
                {emphasis}
              </p>
            </div>
          </div>

          {/* Image */}
          <picture className="block w-full max-w-[360px] mx-auto lg:max-w-none lg:flex-1 lg:min-w-0">
            <source media="(min-width: 1024px)" srcSet={imageUrl} />
            <img
              src={imageUrlMobile}
              alt={imageAlt}
              className="w-full h-auto object-contain"
            />
          </picture>
        </div>
      </div>
    </section>
  )
}
